{
  "close": "Chiudi",
  "notifications": "Notifiche"
}
